<template>
  <div class="common__pageContainer__3-VhW">
    <div class="common__pageBody__1Dn3a">
      <div class="venueStyle__pages__3golT undefined venueStyle__dj__3onOP" style="background-image: url(https://www.8899851.com/oubo/static/image/bg-ob.de4eacec841b7bb8ea0a3e5dede4bcdc.jpg); height: 800px">
        <img :src="`https://www.8899851.com/oubo/static/image/gaming/${type}.png`"  height="100%" class="venueStyle__djBg__2BW34" style="opacity: 1" />
        <div class="venueStyle__content__37kNp" v-for="(item, index) in $store.state.gamingList" :key="index" v-if="type == index">
          <div class="venueStyle__modelsDj__30CtN"><img :src="`https://www.8899851.com/oubo/static/image/gaming/${item.platform_name}_gaming_left.png`" width="800px" class="" style="left: -261px; opacity: 1; zoom: 1" /></div>
          <div class="venueStyle__contentLeft__3bmvb">
            <img :src="`https://www.8899851.com/oubo/static/image/gaming/${item.platform_name}_gaming_title.png`" width="630px" class="venueStyle__title__K3KhH" style="width: 450px; min-height:120px;opacity: 1; margin-left: 0px" /><img
              src="https://www.8899851.com/oubo/static/image/anm-ob-1.a8f00566894e5e6da6e0d5a595278bc7.png"
              class="venueStyle__apng__ppVvF"
              style="z-index: 3"
            /><img src="https://www.8899851.com/oubo/static/image/anm-ob-2.6bd188c6fd7022b9036f66ba0476ba85.png" class="venueStyle__apng__ppVvF" style="z-index: -1" /><span class="venueStyle__subTitle__2nKwg"
              >丰富的电竞赛事，玩法多元，结算快捷。高清直播让您体验精彩热血竞技，是最受玩家喜爱的竞猜娱乐平台。
              <ul class="venueStyle__icons__kTABJ"></ul>
            </span>
            <a @click="$parent.openGamePage(item.platform_name, item.game_code, '')" id="gotogames"> <img src="https://www.8899851.com/oubo/static/image/btn.6ae85c77b9899a7e4590b47da7b41266.png" width="342px" class="venueStyle__btn__HuPwB" style="margin-top: 18px; margin-bottom: 11px" /></a>
            <div><img src="https://www.8899851.com/oubo/static/image/logos.d5c2cb0861129c60db8fbec3508a45c7.png" width="487px" class="" style="" /></div>
          </div>
          <div class="venueStyle__models__zXaM0"><img :src="`https://www.8899851.com/oubo/static/image/gaming/${item.platform_name}_gaming_right.png`" width="800px" class="" style="right: -240px; opacity: 1; zoom: 1" /></div>
          <ul class="venueStyle__tabs__3wTus">
            <li class="venueStyle__tabItem__11CR_" v-for="(item, index) in $store.state.gamingList" :key="index" @click="changType(index)">
              <img v-if="type == index" :src="`https://www.8899851.com/oubo/static/image/gaming/${item.platform_name}_gaming_active.png`" width="212px" style="" />
              <img v-else :src="`https://www.8899851.com/oubo/static/image/gaming/${item.platform_name}_gaming_inactive.png`" width="212px" style="" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'gaming',
  data() {
    return {
      type: 0,
    };
  },
  created() {
    let that = this;
  },
  methods: {
    changType(index) {
      let that = this;
      that.type = index;
      
    },
  },
  mounted() {
    let that = this;
        $('.venueStyle__modelsDj__30CtN img').css({ 'margin-left': '-264px' });
    $('.venueStyle__modelsDj__30CtN img').animate({ 'margin-left': '0px' }, 400);
    $('.venueStyle__models__zXaM0 img').css({ 'right': '-500px' });
    $('.venueStyle__models__zXaM0 img').animate({ 'right': '-240px' }, 400);
    $('.venueStyle__title__K3KhH').hide(200)
    $('.venueStyle__title__K3KhH').show(200)
  },
  updated() {
    let that = this;
    $('.venueStyle__modelsDj__30CtN img').css({ 'margin-left': '-264px' });
    $('.venueStyle__modelsDj__30CtN img').animate({ 'margin-left': '0px' }, 400);
    $('.venueStyle__models__zXaM0 img').css({ 'right': '-500px' });
    $('.venueStyle__models__zXaM0 img').animate({ 'right': '-240px' }, 400);
    $('.venueStyle__title__K3KhH').hide(200)
    $('.venueStyle__title__K3KhH').show(200)
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/Lottery_793450d6.8907158d.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/gaming.vue